import { useAppStore, useTVStore } from '@/shared/store'
import { defaultProfile } from '@/shared/constants'
import { getFavorites } from './FavoritesRepositoryStreamIQ'
import { FavoriteItem } from '@/clients/streamiq/types/vodStreamIQTypes'

const useFavoritesChannelsStreamIQ = () => {
    const { actualProfile } = useAppStore()
    const { setFavoriteChannels } = useTVStore()

    const getFavoritesChannels = async () => {
        if (!actualProfile) return

        const { id } = actualProfile

        if (id === defaultProfile.id) return

        const favoriteChannels = await getFavorites(id)

        if (!favoriteChannels?.length) {
            setFavoriteChannels([])
            return
        }

        const channels = favoriteChannels.filter(
            (item: FavoriteItem) => item.reference.type === 'channel'
        )

        const uniqueSet: Set<string> = new Set()
        channels?.forEach((item: FavoriteItem) => {
            uniqueSet.add(String(item.reference.id))
        })

        const uniqueArray = [...uniqueSet]

        setFavoriteChannels(uniqueArray)
    }

    return { getFavoritesChannels }
}

export default useFavoritesChannelsStreamIQ
